const xoGDelayRender = 500;
const XOGalleries = [];
window.addEventListener('DOMContentLoaded',function(){
  const allTabsHeader = document.querySelectorAll(".tablinks-cus");
  if (allTabsHeader.length > 0) {
    for (let i = 0; i < allTabsHeader.length; i++) {
      allTabsHeader[i].addEventListener("click", function() {
        setTimeout(() => {
          for(let i = 0; i < XOGalleries.length; i++) {
        console.log('aaaa123', XOGalleries);
            XOGalleries[i].forceResize();
          }
        }, 3000);
      });

    }
  }
});
